// Static list of Indian states/UTs and their major cities
// Used for the delivery address state & city dropdowns

export const INDIA_STATES = [
  "Andhra Pradesh",
  "Arunachal Pradesh",
  "Assam",
  "Bihar",
  "Chhattisgarh",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jharkhand",
  "Karnataka",
  "Kerala",
  "Madhya Pradesh",
  "Maharashtra",
  "Manipur",
  "Meghalaya",
  "Mizoram",
  "Nagaland",
  "Odisha",
  "Punjab",
  "Rajasthan",
  "Sikkim",
  "Tamil Nadu",
  "Telangana",
  "Tripura",
  "Uttar Pradesh",
  "Uttarakhand",
  "West Bengal",
  // Union Territories
  "Andaman & Nicobar Islands",
  "Chandigarh",
  "Dadra & Nagar Haveli and Daman & Diu",
  "Delhi",
  "Jammu & Kashmir",
  "Ladakh",
  "Lakshadweep",
  "Puducherry",
];

export const INDIA_CITIES = {
  "Andhra Pradesh": [
    "Visakhapatnam", "Vijayawada", "Guntur", "Nellore", "Kurnool",
    "Tirupati", "Rajahmundry", "Kakinada", "Kadapa", "Anantapur",
    "Vizianagaram", "Ongole", "Eluru", "Bhimavaram", "Chittoor",
  ],
  "Arunachal Pradesh": [
    "Itanagar", "Naharlagun", "Pasighat", "Namsai", "Bomdila",
    "Ziro", "Along", "Tezu",
  ],
  "Assam": [
    "Guwahati", "Silchar", "Dibrugarh", "Jorhat", "Nagaon",
    "Tinsukia", "Tezpur", "Bongaigaon", "Dhubri", "Diphu",
    "Sivasagar", "Goalpara", "Barpeta",
  ],
  "Bihar": [
    "Patna", "Gaya", "Bhagalpur", "Muzaffarpur", "Purnia",
    "Darbhanga", "Arrah", "Begusarai", "Katihar", "Munger",
    "Chapra", "Samastipur", "Hajipur", "Saharsa",
  ],
  "Chhattisgarh": [
    "Raipur", "Bhilai", "Bilaspur", "Korba", "Durg",
    "Rajnandgaon", "Jagdalpur", "Raigarh", "Ambikapur",
  ],
  "Goa": [
    "Panaji", "Margao", "Vasco da Gama", "Mapusa", "Ponda",
    "Bicholim", "Calangute", "Madgaon",
  ],
  "Gujarat": [
    "Ahmedabad", "Surat", "Vadodara", "Rajkot", "Bhavnagar",
    "Jamnagar", "Junagadh", "Gandhinagar", "Anand", "Navsari",
    "Morbi", "Nadiad", "Surendranagar", "Bharuch", "Mehsana",
    "Valsad", "Porbandar", "Godhra",
  ],
  "Haryana": [
    "Faridabad", "Gurgaon", "Panipat", "Ambala", "Yamunanagar",
    "Rohtak", "Hisar", "Karnal", "Sonipat", "Panchkula",
    "Bhiwani", "Sirsa", "Bahadurgarh", "Rewari", "Kaithal",
  ],
  "Himachal Pradesh": [
    "Shimla", "Manali", "Dharamsala", "Solan", "Mandi",
    "Kullu", "Palampur", "Baddi", "Nahan", "Hamirpur",
  ],
  "Jharkhand": [
    "Ranchi", "Jamshedpur", "Dhanbad", "Bokaro", "Deoghar",
    "Phusro", "Hazaribagh", "Giridih", "Ramgarh", "Medininagar",
  ],
  "Karnataka": [
    "Bengaluru", "Mysuru", "Hubballi", "Mangaluru", "Belagavi",
    "Kalaburagi", "Ballari", "Vijayapura", "Shivamogga", "Tumakuru",
    "Davanagere", "Bidar", "Udupi", "Raichur", "Hassan",
    "Dharwad", "Chitradurga", "Kolar", "Mandya",
  ],
  "Kerala": [
    "Thiruvananthapuram", "Kochi", "Kozhikode", "Thrissur", "Kollam",
    "Palakkad", "Kannur", "Alappuzha", "Malappuram", "Kottayam",
    "Ernakulam", "Kasaragod", "Pathanamthitta", "Idukki",
  ],
  "Madhya Pradesh": [
    "Indore", "Bhopal", "Jabalpur", "Gwalior", "Ujjain",
    "Sagar", "Satna", "Rewa", "Dewas", "Burhanpur",
    "Chhindwara", "Ratlam", "Shivpuri", "Katni", "Singrauli",
    "Morena", "Bhind", "Guna",
  ],
  "Maharashtra": [
    "Mumbai", "Pune", "Nagpur", "Nashik", "Aurangabad",
    "Solapur", "Kolhapur", "Thane", "Amravati", "Nanded",
    "Sangli", "Satara", "Latur", "Akola", "Jalgaon",
    "Ratnagiri", "Dhule", "Ahmednagar", "Chandrapur", "Parbhani",
    "Navi Mumbai", "Malegaon",
  ],
  "Manipur": [
    "Imphal", "Thoubal", "Bishnupur", "Churachandpur", "Kakching",
    "Senapati", "Ukhrul",
  ],
  "Meghalaya": [
    "Shillong", "Tura", "Jowai", "Nongstoin", "Baghmara",
    "Cherrapunji",
  ],
  "Mizoram": [
    "Aizawl", "Lunglei", "Champhai", "Kolasib", "Serchhip",
  ],
  "Nagaland": [
    "Kohima", "Dimapur", "Mokokchung", "Wokha", "Zunheboto",
    "Tuensang",
  ],
  "Odisha": [
    "Bhubaneswar", "Cuttack", "Rourkela", "Brahmapur", "Sambalpur",
    "Puri", "Balasore", "Bhadrak", "Baripada", "Jharsuguda",
    "Angul", "Bargarh", "Kendujhar",
  ],
  "Punjab": [
    "Ludhiana", "Amritsar", "Jalandhar", "Patiala", "Bathinda",
    "Hoshiarpur", "Pathankot", "Moga", "Firozpur", "Mohali",
    "Sangrur", "Fatehgarh Sahib", "Rupnagar",
  ],
  "Rajasthan": [
    "Jaipur", "Jodhpur", "Kota", "Bikaner", "Udaipur",
    "Ajmer", "Bhilwara", "Alwar", "Bharatpur", "Sikar",
    "Sri Ganganagar", "Pali", "Tonk", "Jhunjhunu", "Barmer",
    "Nagaur", "Chittorgarh", "Beawar",
  ],
  "Sikkim": [
    "Gangtok", "Namchi", "Mangan", "Gyalshing",
  ],
  "Tamil Nadu": [
    "Chennai", "Coimbatore", "Madurai", "Tiruchirappalli", "Salem",
    "Tirunelveli", "Erode", "Vellore", "Thoothukudi", "Tiruppur",
    "Dindigul", "Thanjavur", "Ranipet", "Sivakasi", "Karur",
    "Udhagamandalam", "Hosur", "Nagercoil", "Kancheepuram", "Kumarakoil",
  ],
  "Telangana": [
    "Hyderabad", "Warangal", "Nizamabad", "Khammam", "Karimnagar",
    "Ramagundam", "Mahbubnagar", "Nalgonda", "Adilabad", "Suryapet",
    "Miryalaguda", "Siddipet", "Secunderabad",
  ],
  "Tripura": [
    "Agartala", "Dharmanagar", "Udaipur", "Kailasahar", "Ambassa",
  ],
  "Uttar Pradesh": [
    "Lucknow", "Kanpur", "Ghaziabad", "Agra", "Meerut",
    "Varanasi", "Allahabad (Prayagraj)", "Noida", "Bareilly", "Aligarh",
    "Moradabad", "Saharanpur", "Gorakhpur", "Firozabad", "Mathura",
    "Jhansi", "Muzaffarnagar", "Rampur", "Shahjahanpur", "Farrukhabad",
    "Hapur", "Ayodhya", "Hathras", "Bulandshahr",
  ],
  "Uttarakhand": [
    "Dehradun", "Haridwar", "Roorkee", "Haldwani", "Rudrapur",
    "Kashipur", "Rishikesh", "Mussoorie", "Nainital", "Pithoragarh",
    "Almora",
  ],
  "West Bengal": [
    "Kolkata", "Asansol", "Siliguri", "Durgapur", "Bardhaman",
    "Malda", "Barasat", "Krishnanagar", "Howrah", "Haldia",
    "Kharagpur", "Cooch Behar", "Jalpaiguri", "Bankura", "Raiganj",
  ],
  "Andaman & Nicobar Islands": [
    "Port Blair", "Diglipur", "Rangat",
  ],
  "Chandigarh": [
    "Chandigarh",
  ],
  "Dadra & Nagar Haveli and Daman & Diu": [
    "Silvassa", "Daman", "Diu",
  ],
  "Delhi": [
    "New Delhi", "Delhi", "Dwarka", "Noida (Delhi NCR)", "Gurugram (Delhi NCR)",
    "Rohini", "Pitampura", "Janakpuri", "Laxmi Nagar", "Saket",
    "Connaught Place", "Karol Bagh",
  ],
  "Jammu & Kashmir": [
    "Srinagar", "Jammu", "Anantnag", "Baramulla", "Sopore",
    "Kathua", "Udhampur", "Punch",
  ],
  "Ladakh": [
    "Leh", "Kargil",
  ],
  "Lakshadweep": [
    "Kavaratti", "Agatti",
  ],
  "Puducherry": [
    "Puducherry", "Karaikal", "Yanam", "Mahe",
  ],
};

/**
 * Returns the list of cities for a given state name.
 * Case-insensitive match with fallback to empty array.
 */
export function getCitiesForState(stateName) {
  if (!stateName) return [];
  // Try exact match first
  if (INDIA_CITIES[stateName]) return INDIA_CITIES[stateName];
  // Case-insensitive fallback
  const key = Object.keys(INDIA_CITIES).find(
    (k) => k.toLowerCase() === stateName.toLowerCase()
  );
  return key ? INDIA_CITIES[key] : [];
}

/**
 * Normalise a Google Maps state name to our list key.
 * Returns the matched state string, or the original if not found.
 */
export function normaliseState(googleStateName) {
  if (!googleStateName) return "";
  // Exact match
  if (INDIA_STATES.includes(googleStateName)) return googleStateName;
  // Case-insensitive
  const match = INDIA_STATES.find(
    (s) => s.toLowerCase() === googleStateName.toLowerCase()
  );
  return match || googleStateName;
}
